import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_99: DocMigration = {
  maxSchemaVersion: "0.0.99",
  description: "Refactor roomLayout.baseLayoutId from string to useBuiltinLayout boolean",
  apply(json: any) {
    if (json.roomLayouts) {
      const updatedRoomLayouts = {};
      for (const roomId in json.roomLayouts) {
        const roomLayout = json.roomLayouts[roomId];

        if (
          roomLayout.baseLayoutId === null ||
          roomLayout.baseLayoutId === "undefined" ||
          roomLayout.baseLayoutId !== ""
        ) {
          delete roomLayout.baseLayoutId;
          updatedRoomLayouts[roomId] = {
            ...roomLayout,
            useBuiltinLayout: false,
          };
        } else if (roomLayout.baseLayoutId === "" || !roomLayout.baseLayoutId) {
          delete roomLayout.baseLayoutId;
          updatedRoomLayouts[roomId] = {
            ...roomLayout,
            useBuiltinLayout: true,
          };
        }
      }

      return {
        ...json,
        roomLayouts: updatedRoomLayouts,
      };
    }

    return json;
  },
};

export default migration_0_0_99;
